<template>
    <el-dialog title="Rename List View"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <h3>Name</h3>
        <input type="text" class="form-control" v-model="form_name"></input>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save()">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        props: [
            'show',
            'name',
            'view_id'
        ],
        data() {
            return {
                form_name: ''
            };
        },
        watch: {
            name() {
                this.form_name = this.name;
            }
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
                return axios.post(url(`admin/views/rename`), {
                        view_id: this.view_id,
                        name: this.form_name
                    }).then(() => {
                        this.$emit('updated');
                        this.showForm = false;
                    });
            }
        }
    }
</script>

<style scoped>
</style>